import type { BridgeMessageHandler } from '../../routing/message-router.js';

export const handleBridgeHeartbeatAck: BridgeMessageHandler<'ha'> = (msg, deps) => {
  const raw = msg.s;
  if (typeof raw !== 'number' || !Number.isFinite(raw)) return;
  deps.onBridgeHeartbeatAck?.(Math.trunc(raw));
};
